<template>
    <v-col>
        <v-col style="padding-bottom:10px">
            <v-row>
                <v-flex>
                    <v-btn elevation="0" style="padding-right:10px;">
                        <v-icon
                                @click="back()"
                        >mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-text justify-center class="ma-5 font-weight-bold justify-center" style="font-size:20px; padding-left:10px;">  Tijdslijn bekijken</v-text></v-flex>

            </v-row>
        </v-col>
        <v-divider></v-divider>

        <v-col style="padding-top:2px;">
            <v-row>
                <v-card
                        width="100%"
                        outlined
                        class="rounded-card"
                        style="border-radius:15px;"
                >
                    <TimeComponent justify="center" :filter="filterId"></TimeComponent>
                </v-card>
            </v-row>
            <v-row>

                <v-col class="pa-1">
                    <v-expansion-panels class="some" v-model="panel">
                        <v-expansion-panel
                                v-for="(alarm, i) in alarms"
                                :key="i"
                                elevation="0"
                                class="elevation-0"
                                style="border-radius:15px; margin:3px; box-shadow:none; -webkit-box-shadow: none; -moz-box-shadow: none;"
                                flat
                                accordion
                        >
                            <v-expansion-panel-header elevation="0" class="elevation-0">
                                <v-row>
                                    <v-col cols="auto" class="ma-0">
                                        <v-img v-if="alarm.type === 'alert' && alarm.completed"
                                               src="./../assets/alarm_handled.png"
                                               height="20px"
                                               width="20px"
                                        />
                                        <v-img v-if="alarm.type === 'alert' && !alarm.completed"
                                               src="./../assets/alarm_pending.png"
                                               height="20px"
                                               width="20px"
                                        />
                                        <v-img v-if="alarm.type === 'notification' && alarm.completed"
                                               src="./../assets/notification_handled.png"
                                               height="20px"
                                               width="20px"
                                        />
                                        <v-img v-if="alarm.type === 'notification' && !alarm.completed"
                                               src="./../assets/notification_pending.png"
                                               height="20px"
                                               width="20px"
                                        />

                                        <v-img v-if="alarm.type === 'info' && alarm.completed"
                                               src="./../assets/event_handled.png"
                                               height="20px"
                                               width="20px"
                                        />
                                        <v-img v-if="alarm.type === 'info' && !alarm.completed"
                                               src="./../assets/event_pending.png"
                                               height="20px"
                                               width="20px"
                                        />
                                    </v-col>
                                    <v-col cols="auto" class="ml-1">
                                        <v-text class="font-weight-medium" >{{alarm.name}}</v-text>

                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-text>Afgehandeld op: {{alarm.timestamp.substr(0,10)}}</v-text>
                                <pre></pre>
                                <v-text>Afgehandeld door: {{alarm.acceptee}}</v-text>
                                <pre></pre>
                                <v-text>Opmerkingen: </v-text><pre></pre>
                                <v-text v-for="(step, i) in alarm.workflow" :key="i">{{step.notes}}</v-text>



                            </v-expansion-panel-content>


                        </v-expansion-panel>
                    </v-expansion-panels>

                </v-col>

            </v-row>
        </v-col>
    </v-col>
</template>

<script>
    import axios from "axios";
    import config from "@/config/config";
    import TimeComponent from "@/components/TimeComponent";

    export default {
        name: "TimeLineItem",
        data: () => ({
            alarms: [],
            finished: 0,
            max: 0,
            status: '',
            images: {
                alert: require('../assets/alert_workflow.png'),
                notification: require('../assets/notification_workflow.png'),
                info: require('../assets/info_workflow.png')
            },
            filterId: undefined
        }),
        methods: {
            back() {
                this.dialog = false;
                this.$router.go(-1);
            },
            completed(i) {
                if(this.alarms[i].completed) {
                    return "Ja"
                } else {
                    return "Nee"
                }
            },
            convertTimestamp(ts) {
                let date = new Date(ts)
                let today = new Date()
                if(date.getDate() < today.getDate()) {
                    if (date.getMinutes() < 10 && date.getHours() < 10) {
                        return "0" + date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + date.getMonth()+1 + ")"
                    } else if(date.getMinutes() < 10) {
                        return date.getHours() + ":0" + date.getMinutes()+ " (" + date.getDate() + "/" + date.getMonth()+1 + ")"
                    } else if(date.getHours() < 10) {
                        return "0" + date.getHours()+":" + date.getMinutes()+ " (" + date.getDate() + "/" + date.getMonth()+1 + ")"
                    }
                    return date.getHours() + ":" + date.getMinutes() + " (" + date.getDate() + "/" + date.getMonth()+1 + ")"
                }
                if (date.getMinutes() < 10 && date.getHours() < 10) {
                    return "0" + date.getHours() + ":0" + date.getMinutes()
                } else if(date.getMinutes() < 10) {
                    return date.getHours() + ":0" + date.getMinutes()
                } else if(date.getHours() < 10) {
                    return "0" + date.getHours()+":" + date.getMinutes()
                }
                return date.getHours() + ":" + date.getMinutes()
            }
        },
        mounted () {
            let filter = this.$route.query.filter
            axios
                .post(config.url + '/alarms/singlehistory/' + filter).then((res) => {
                // eslint-disable-next-line no-console
                console.log("LEEE")
                // eslint-disable-next-line no-console
                console.log(res)
                this.alarms = res.data.alarms;
                if(this.alarms[0]) {
                    this.filterId = this.alarms[0].log_filter_id
                }
            })
        },
        components: {
            TimeComponent
        }
    }
</script>

<style scoped>
    .rounded-card{
        border-radius:50px;
        margin: 5px;
        background: #ffffff;
        border-color: grey;
    }

    .some .v-expansion-panel::after * {
        border-top: none !important;
        border-top-width: 0 !important;
    }

    .v-expansion-panels {
        box-shadow: none !important;
    }

    .v-expansion-panel {
        border: 1px solid !important;
    }

    .v-expansion-panel:before { box-shadow: none !important; }
    .v-expansion-panel:after { border-top: none !important; }

    .v-timeline-item {
        padding-bottom: 5px !important;
    }

    .v-timeline {
        padding-top: 5px !important;
    }
    .some-icon {
        height: 40px !important;
        width: 40px !important;
        float: right;
        margin-top: 17px;
        margin-right: 2px;
    }
</style>
